export const NAME = 'changeHistory';
export const LEVEL_ONE = 'ChangeHistoryComponentReducer';
